import { render, staticRenderFns } from "./RviewOrder.vue?vue&type=template&id=e65bc2fa&scoped=true"
import script from "./RviewOrder.vue?vue&type=script&lang=js"
export * from "./RviewOrder.vue?vue&type=script&lang=js"
import style0 from "./RviewOrder.vue?vue&type=style&index=0&id=e65bc2fa&prod&scoped=true&lang=scss"
import style1 from "./RviewOrder.vue?vue&type=style&index=1&id=e65bc2fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65bc2fa",
  null
  
)

export default component.exports